import { useAutoAnimate } from "@formkit/auto-animate/react";
import React, { useEffect } from "react";
import { Modal } from "react-bootstrap";
import { FormProvider, useForm } from "react-hook-form";
import { confirmable, createConfirmation } from "../../../hooks/DialogMountPoint";
import { CloseLoopDashboardDefaultFilters } from "../../../hooks/FilterContext";
import Button from "../../buttons";
import ThemedModal from "../../utilities/ThemedModal";
import CloseLoopFilterForm from "./form";
import { CloseLoopFilter, CloseLoopFilterModalProps } from "./types";

const CloseLoopFiltersModal = ({
    backdrop = 'static',
    cancel,
    centered = true,
    defaultFilters,
    defaultValues,
    dialogId,
    dismiss,
    proceed,
    size = 'lg',
    ...rest
}: Readonly<CloseLoopFilterModalProps>) => {
    const [bodyAnimation] = useAutoAnimate();
    const form = useForm<CloseLoopFilter>();
    const { handleSubmit, reset } = form;

    const onClose = () => cancel!();
    const onClearFilters = () => reset(defaultFilters);
    const onSubmit = (form: CloseLoopFilter) => proceed!(form);

    useEffect(() => {
        if (!defaultValues)
            return;

        reset(defaultValues);
    }, [defaultValues, reset]);

    return <Modal {...rest} onHide={onClose} backdrop={backdrop} centered={centered} size={size}>
        <ThemedModal.Header>
            <Modal.Title>Close Loop Filters</Modal.Title>
        </ThemedModal.Header>
        <FormProvider {...form}>
            <form onSubmit={handleSubmit(onSubmit)}>
                <Modal.Body ref={bodyAnimation}>
                    <CloseLoopFilterForm />
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="warning" type="button" onClick={onClearFilters}>Clear Filters</Button>
                    <Button variant="success" type="submit">Apply Filters</Button>
                    <Button variant="light" type="button" onClick={onClose}>Cancel</Button>
                </Modal.Footer>
            </form>
        </FormProvider>
    </Modal>;
};

export function openCloseLoopFiltersModal(filters: CloseLoopFilter) {
    return createConfirmation<CloseLoopFilterModalProps, CloseLoopFilter>(confirmable((props) => {
        return <CloseLoopFiltersModal {...props} />;
    }))({
        dialogId: 'close_loop_filter_modal',
        defaultFilters: CloseLoopDashboardDefaultFilters,
        defaultValues: filters
    });
}